import TournamentDetailsModal from '@pages/gamers/tournament-details/tournament-details';
export default TournamentDetailsModal;
